<div class="table-container" [ngClass]="{bordered : showBorder}" >
    <div class="row header" *ngIf="showHeader">
      <div
        *ngFor="let c of columns"
        class="data" style="font-weight: bold;"
        >
        {{c.name}}
      </div>
    </div>
    <div class="body-container">
      <div *ngFor="let d of data ; let i = index" class="row body scrollbar" id="style-1">
        <div
          class="data"
          *ngFor="let c of columns"
        >
          <ng-container *ngIf="c.type === 'value'">
            {{d[c.key]}}
          </ng-container>
          <ng-container *ngIf="c.type === 'check'">
            <input
              type="checkbox"
              (change)="_checked(d , c , i)"
              [checked]="d[c.key]"
              [(ngModel)]="d[c.key]"

            >
          </ng-container>
        </div>
      </div>
    </div>
  </div>
